﻿{
  "community": {
    "name": "Comunidade",
    "titles": {
      "1": "Comunidade online",
      "2": "Encontrar materiais",
      "3": "Compartilhe suas criações"
    },
    "body": {
      "1": "Um ótimo lugar para mergulhar de cabeça e conferir as ofertas do Boardmaker",
      "2": "Veja o que outras pessoas estão criando e compartilhando. É como uma janela para a mágica do Boardmaker!",
      "3": "Faça upload e compartilhe o que você criou com a comunidade através do seu software Boardmaker preferido"
    }
  },
  "personal": {
    "name": "Pessoal",
    "header": "Inclui toda a Comunidade, mais:",
    "titles": {
      "1": "Crie, edite, reproduza e imprima",
      "2": "Software Boardmaker"
    },
    "body": {
      "1": "Para pais ou cuidadores de crianças que queiram criar, editar, reproduzir e imprimir atividades",
      "2": "As contas incluem uma licença Boardmaker 7 que pode ser instalada em até 2 computadores Windows."
    }
  },
  "professional": {
    "name": "Profissional",
    "header": "Inclui todo o Pessoal, mais:",
    "titles": {
      "1": "Gerenciador de alunos",
      "2": "Configurações individualizadas"
    },
    "body": {
      "1": "Para professores com 1 a 50 alunos que queiram passar atividades e monitorar os dados do aluno",
      "2": "Configurações de acesso personalizadas para cada aluno"
    }
  },
  "organization": {
    "name": "Instituição",
    "header": "Inclui todo o Profissional, mais:",
    "titles": {
      "1": "Assistência com equipe multidisciplinar"
    },
    "body": {
      "1": "Preço por volume: a instituição controla as informações e diversas pessoas podem enviar tarefas para os mesmos alunos"
    }
  }
}
